export const formatPercentage = (value: number, decimalPlaces = 2): string => {
  return `${(100 * value).toFixed(decimalPlaces)}%`.replace(/\./g, ',');
};
